import ComicCard from '@/components/feature/ComicCard';
import type { Comic } from '@/mocks/comics';

interface LatestUpdatesProps {
  comics: Comic[];
}

export default function LatestUpdates({ comics }: LatestUpdatesProps) {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              最新连载，追更不等待
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {comics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}